// Assets Card Component
export default {
  // Title
  totalAssetBalance: "Total Asset Balance",

  // Tooltip
  balanceDescription:
    "The total asset balance of the address is calculated based on the currency values included in this system, converted to USDT according to all main coins and tokens held by the address",
  systemSupport: "The system currently supports",
  currencyCount: "317 currencies",

  // Unit
  usdtUnit: "USDT",
};
